import { LUDUM_ATTENDANCE_STATUSES } from '@/constants';
const { ATTENDING, NOT_ATTENDING } = LUDUM_ATTENDANCE_STATUSES;

export const addResultsAttendance = {
    namespaced: true,

    state: {
        session: null
    },

    getters: {
        preparedHealthStatuses(state) {
            const statuses = {};

            if (state.session) {
                _.each(state.session.participants.data, participant => {
                    Vue.set(statuses, participant.user_id, {
                        attending: !participant.not_attending ? ATTENDING : NOT_ATTENDING
                    });

                    if (_.has(participant, 'health_statuses')) {
                        Vue.set(statuses[participant.user_id], 'health_statuses', {});

                        _.each(participant.health_statuses, status => {
                            Vue.set(statuses[participant.user_id].health_statuses, status.id, status.selected ? 1 : 0);
                        });
                    }
                });
            }

            return statuses;
        }
    },

    actions: {
        setSessionAttendance(context, payload) {
            context.state.session = payload.session;

            const preparedHealthStatuses = context.getters.preparedHealthStatuses;

            return context.dispatch(
                'addResultsErgo/setSessionAttendance',
                {
                    data: {
                        event_id: payload.session.id,
                        users: preparedHealthStatuses
                    }
                },
                { root: true }
            );
        }
    }
};
